import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User, AuthorizationData } from '../models';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Config } from '../config';
import { UserService } from './user.service';

@Injectable()

export class AuthenticationService implements OnInit {
    public user: User;
    private gettingUserProfile: boolean;

    constructor(
        private config: Config,
        private userService: UserService,
        private http: HttpClient
    ) {}

    ngOnInit() {
        console.log("AuthenticationService", this.user);
        this.gettingUserProfile = true;
        this.userService.getProfile().subscribe(user => this.user = user);
    }

    login(username: string, password: string): Observable<AuthorizationData> {
        const params = {
            username,
            password
        };

        /*
        return new Observable(observer => {
          localStorage.setItem('access_token', 'mockToken');
          let ad = new AuthorizationData();
          ad.token = 'mockToken';
          observer.next(ad);
        });
        */

        return this.http.post<AuthorizationData>(this.config.get('API_SERVER_URL') + '/auth/login', params, { headers: { 'Access-Control-Allow-Origin': '*' } })
            .pipe(
                map(res => {
                    localStorage.setItem('access_token', res.token);
                    this.gettingUserProfile = true;
                    this.userService.getProfile().subscribe(user => this.user = user);

                    return res;
                })
            );
    }

    resetPassword(login: string): Observable<HttpResponse<void>> {
        return this.http.post<HttpResponse<void>>(this.config.get('API_SERVER_URL') + '/auth/reset', login);
    }

    isUserInRole(role: string): boolean {
        let token = localStorage.getItem('access_token');
        if (token == null) {
            return false;
        }
        if (!this.user && !this.gettingUserProfile) {
            this.gettingUserProfile = true;
            this.userService.getProfile().subscribe(
                user => this.user = user,
                error => {
                    this.user = null;
                    token = null;
                    localStorage.removeItem('access_token');
                    return false;
                });
        }

        let jwtHelper = new JwtHelperService();
        let decodedToken = jwtHelper.decodeToken(token);
        if (decodedToken) {
            let roles: string = decodedToken.roles;
            let rolesArray: Array<string> = roles.split(",");
            if (roles) {
                return rolesArray.includes(role);
            }
        }
        return false;
    }

    logout(): Observable<HttpResponse<void>> {
        /*
        return new Observable(observer => {
          console.log('Ala ma kota', localStorage);
          localStorage.clear();
          observer.next();
        });
        */
        return this.http.get(this.config.get('API_SERVER_URL') + '/auth/logout')
            .pipe(
                map((respose: HttpResponse<void>) => {
                    localStorage.removeItem("access_token");
                    this.user = null;
                    this.gettingUserProfile = false;
                    return respose;
                })
            );
    }
}
